import React from 'react';
import { Button, Divider, Grid2 as Grid, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { useTheme } from '@mui/system';
import { A } from 'hookrouter';
import { IntegrationStatus } from '@idearoom/types';
import chartIconSrc from '../../images/chartIcon.svg';
import { I18nKeys } from '../../constants/I18nKeys';
import { MenuIcon, MenuIconKey } from '../MenuIcon';
import { openDialog } from '../../ducks/dialogSlice';
import { Dialogs } from '../../constants/Dialogs';
import { startPaymentIntegration } from '../../ducks/integrationSlice';
import { AppRoutes } from '../../constants/AppRoutes';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { SetupPaymentIntegrationDialog } from './SetupPaymentIntegrationDialog';
import { SetupPaymentIntegrationConfirmationDialog } from './SetupPaymentIntegrationConfirmationDialog';
import { MainMenuItems } from '../../constants/MainMenuItems';
import { isIdeaRoomUser } from '../../utils/userUtils';
import { setMainMenuItem } from '../../ducks/menuSlice';

const ReachMoreCustomerIcon = () => {
  const theme = useTheme();
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.66232 6.6602L3.76839 6.76626C3.37432 7.16034 3.15268 7.69453 3.15201 8.25178C3.15201 8.25184 3.15201 8.25189 3.15201 8.25195M3.66232 6.6602L3.00201 8.25178L3.15201 8.25195M3.66232 6.6602L3.76839 6.76626C4.16237 6.37227 4.69675 6.15063 5.25408 6.15L32.1151 6.15C32.6724 6.15064 33.2066 6.37229 33.6007 6.76628C33.9947 7.16039 34.2163 7.69464 34.217 8.25195L34.2172 21.6915C34.2164 22.091 34.1022 22.4819 33.8879 22.819L33.8432 22.8894L33.8794 22.9646C34.5232 24.2999 34.7618 25.7944 34.5659 27.2637C34.3699 28.733 33.7481 30.1128 32.7769 31.2327C31.8057 32.3526 30.5279 33.1636 29.1012 33.5656C27.6743 33.9676 26.1611 33.943 24.7481 33.4947C23.3351 33.0465 22.0843 32.1943 21.1502 31.0435L21.0338 31.1381L21.1502 31.0435C20.216 29.8927 19.6394 28.4934 19.4914 27.0185L19.4778 26.8835H19.3421H2.25195C1.6947 26.8828 1.16053 26.6611 0.766394 26.2671C0.372401 25.873 0.150766 25.3389 0.15 24.7816V11.3413C0.150757 10.784 0.372403 10.2499 0.766366 9.85591C1.16046 9.46192 1.69467 9.24031 2.25181 9.23974C2.25184 9.23974 2.25188 9.23974 2.25192 9.23974M3.66232 6.6602L2.25192 9.23974M3.15201 8.25195L3.15201 9.08963V9.23961L3.00203 9.23963L2.25192 9.23974M3.15201 8.25195L2.25192 9.23974M31.5161 20.1545L31.2724 19.9596L31.2722 19.9594L31.3584 19.8424H31.2161V11.3415C31.2154 10.7842 30.9936 10.2499 30.5995 9.85594C30.2054 9.46198 29.6711 9.24044 29.1139 9.23986C29.1138 9.23986 29.1138 9.23986 29.1137 9.23986M31.5161 20.1545L29.1139 9.08986L29.1137 9.23986M31.5161 20.1545V20.1315M31.5161 20.1545V20.1315M29.1137 9.23986L4.82417 9.23986H4.67417V9.08986V8.2519V8.25175C4.67432 8.09789 4.73552 7.95031 4.84435 7.84149C4.95319 7.73264 5.10078 7.67146 5.25473 7.67131L5.25488 7.67131L32.1162 7.67131H32.1163C32.2702 7.67146 32.4178 7.73262 32.5266 7.84141C32.6356 7.95027 32.6968 8.09784 32.6971 8.2516V8.2519V20.8243V21.19L32.4403 20.9296C32.1539 20.6392 31.8449 20.3723 31.5161 20.1315M29.1137 9.23986L31.5161 20.1315M1.67225 11.3413V24.6231L1.67173 24.6231L1.67205 24.7821C1.67235 24.9359 1.73354 25.0833 1.84234 25.1921C1.95114 25.3009 2.09855 25.3621 2.25234 25.3624H2.25263H19.3772H19.5082L19.5258 25.2326C19.7275 23.7478 20.3646 22.3559 21.3566 21.2329C22.3488 20.1098 23.6514 19.3059 25.1 18.9225C26.5484 18.5391 28.0782 18.5935 29.4959 19.0788L29.6945 19.1468V18.9369V11.3413V11.341C29.6942 11.1873 29.633 11.0397 29.5242 10.9309C29.4154 10.8221 29.2679 10.7609 29.1139 10.7607H29.1138H3.97566H3.96412L3.95272 10.7625C3.94551 10.7636 3.93678 10.7639 3.91372 10.7639C3.90972 10.7639 3.90479 10.7636 3.89342 10.7627L3.8919 10.7626C3.88228 10.7619 3.86693 10.7607 3.85077 10.7607H2.25284H2.25269C2.09879 10.7609 1.95134 10.8221 1.84254 10.9309C1.73371 11.0397 1.67255 11.1873 1.67225 11.341V11.3413ZM33.1123 26.2607V26.2606C33.1125 25.0604 32.7568 23.8869 32.09 22.8888C31.4233 21.8907 30.4755 21.1127 29.3667 20.6532C28.2579 20.1937 27.0376 20.0734 25.8604 20.3075C24.6831 20.5415 23.6017 21.1194 22.7528 21.9682C21.9041 22.8168 21.326 23.8982 21.0918 25.0754C20.8576 26.2526 20.9778 27.4729 21.4371 28.5818C21.8964 29.6907 22.6744 30.6385 23.6724 31.3053L23.7557 31.1806L23.6724 31.3053C24.6705 31.9722 25.8438 32.3281 27.0441 32.328L27.0441 32.328C28.6529 32.3261 30.195 31.6862 31.3326 30.5489C32.4702 29.4115 33.1102 27.8694 33.1123 26.2607Z"
        fill={theme.palette.primary.main}
        stroke="white"
        strokeWidth="0.3"
      />
      <path
        d="M20.4071 18.0347L20.4071 18.0168C20.4069 16.7517 19.9042 15.5386 19.0096 14.6443L19.0096 14.6443C18.1151 13.7499 16.9019 13.2475 15.6369 13.2477L20.4071 18.0347ZM20.4071 18.0347C20.401 19.2928 19.8987 20.498 19.0088 21.388C18.1147 22.2824 16.9024 22.7855 15.6376 22.787C14.3727 22.7871 13.1596 22.2847 12.2651 21.3903L12.159 21.4964L12.2651 21.3903C11.3705 20.4959 10.8679 19.2827 10.8678 18.0178C10.8677 16.7528 11.37 15.5396 12.2644 14.6451L12.2644 14.6451C13.1587 13.7505 14.3719 13.2479 15.6369 13.2477L20.4071 18.0347ZM15.6377 21.2661H15.7005L15.7012 21.2654C16.5397 21.2481 17.34 20.9074 17.934 20.3132C18.5429 19.704 18.8854 18.8782 18.8862 18.0169V18.0167C18.8858 17.1551 18.5434 16.3291 17.9341 15.7201C17.3248 15.1111 16.4985 14.7691 15.637 14.7693H15.637C14.7756 14.7695 13.9495 15.1118 13.3404 15.7211C12.7313 16.3304 12.3892 17.1567 12.3894 18.0181C12.3894 18.8796 12.7317 19.7057 13.3409 20.3148C13.9501 20.9239 14.7762 21.2661 15.6377 21.2661Z"
        fill={theme.palette.primary.main}
        stroke="white"
        strokeWidth="0.3"
      />
      <path
        d="M31.0871 24.9846L27.2225 28.8454C27.0518 29.0161 26.8204 29.1118 26.579 29.1118C26.3377 29.1118 26.1062 29.0161 25.9356 28.8454L23.3616 26.2715C23.1807 26.1031 23.0759 25.8684 23.0714 25.6212M31.0871 24.9846L30.4532 23.5573C30.6596 23.5537 30.8587 23.6341 31.0047 23.7801L31.0047 23.7801C31.1507 23.926 31.2311 24.1251 31.2273 24.3316L31.2273 24.3316C31.2236 24.5381 31.1361 24.7341 30.9849 24.8747L30.9848 24.8747L30.981 24.8785L27.1164 28.7393L27.1164 28.7394C26.9739 28.8818 26.7807 28.9618 26.579 28.9618C26.3775 28.9618 26.1841 28.8818 26.0416 28.7394L23.4677 26.1654L23.4678 26.1654L23.4638 26.1617C23.3127 26.021 23.2251 25.825 23.2214 25.6186L23.0714 25.6212M31.0871 24.9846C31.2681 24.8162 31.3728 24.5815 31.3773 24.3343L31.0871 24.9846ZM23.0714 25.6212L23.2214 25.6186C23.2177 25.4121 23.298 25.213 23.444 25.067C23.5901 24.921 23.7891 24.8406 23.9955 24.8444L23.9956 24.8444C24.2021 24.8481 24.3981 24.9355 24.5387 25.0868L24.6446 25.2007L24.6486 25.1966L26.4741 27.0224L26.5801 27.1285L26.6862 27.0224L29.807 23.9013L29.8119 23.9054L29.91 23.7998C30.0506 23.6486 30.2466 23.5611 30.4531 23.5573L23.9983 24.6944C23.7511 24.6899 23.5128 24.7861 23.338 24.9609C23.1632 25.1357 23.067 25.3741 23.0714 25.6212Z"
        fill={theme.palette.primary.main}
        stroke="white"
        strokeWidth="0.3"
      />
    </svg>
  );
};

const SimplifyShoppingIcon = () => {
  const theme = useTheme();
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_566_3750)">
        <path
          d="M24.9272 29.4313H23.3636V19.5268H23.4573C24.2033 19.5268 24.8499 19.0737 25.1046 18.3725C25.3593 17.6712 25.1543 16.9088 24.5822 16.43L13.7315 7.34868C13.0796 6.80304 12.1335 6.80304 11.4817 7.34868L0.630699 16.43C0.058599 16.9088 -0.146481 17.6712 0.108279 18.3725C0.363045 19.0736 1.00969 19.5268 1.75558 19.5268H1.84921V29.431H0.285702C0.127968 29.431 0 29.559 0 29.7167V33.4394C0 33.5971 0.127968 33.7251 0.285702 33.7251H24.9271C25.0848 33.7251 25.2128 33.5971 25.2128 33.4394V29.7167C25.2128 29.5588 25.0848 29.431 24.9271 29.431L24.9272 29.4313ZM22.7922 29.4313H20.3718V19.5268H22.7922V29.4313ZM7.83304 19.5268V29.431L5.41264 29.4311V19.5266L7.83304 19.5268ZM8.40445 19.5268H10.8248V29.431H8.40445V19.5268ZM11.3963 19.5268H13.8167V29.431H11.3963V19.5268ZM14.3882 19.5268H16.8086V29.431H14.3882V19.5268ZM17.38 19.5268H19.8004V29.431H17.38V19.5268ZM11.8483 7.78689C12.0679 7.60303 12.3372 7.51115 12.6064 7.51115C12.8757 7.51115 13.1448 7.60303 13.3645 7.78689L23.4052 16.1902H20.9916L12.7899 9.32589C12.6837 9.23707 12.5293 9.23707 12.4231 9.32589L4.22137 16.1902H1.80766L11.8483 7.78689ZM20.101 16.1902H5.11177L12.6064 9.91749L20.101 16.1902ZM0.645366 18.1776C0.508725 17.8014 0.529467 17.26 0.997506 16.8683L1.12501 16.7616H24.0879L24.2154 16.8683C24.6833 17.26 24.7042 17.8015 24.5675 18.1776C24.431 18.5536 24.0675 18.9555 23.4573 18.9555H1.75561C1.14541 18.9555 0.781896 18.5536 0.645366 18.1776ZM2.42077 19.5269H4.84117V29.4311L2.42077 29.4312V19.5269ZM24.6415 33.1541H0.571566V30.0029H24.6415V33.1541Z"
          fill={theme.palette.primary.main}
        />
        <path
          d="M31.281 7.0546C31.281 7.21234 31.409 7.3403 31.5667 7.3403C31.7245 7.3403 31.8524 7.21234 31.8524 7.0546C31.8524 6.0517 30.9648 5.22214 29.8223 5.10202V4.4815C29.8223 4.32377 29.6943 4.1958 29.5366 4.1958C29.3788 4.1958 29.2509 4.32377 29.2509 4.4815V5.10202C28.1083 5.22214 27.2207 6.0517 27.2207 7.0546C27.2207 8.05762 28.1084 8.88706 29.2509 9.00718V11.7971C28.4245 11.6876 27.7921 11.1116 27.7921 10.4194C27.7921 10.2617 27.6641 10.1337 27.5064 10.1337C27.3487 10.1337 27.2207 10.2617 27.2207 10.4194C27.2207 11.4224 28.1084 12.2519 29.2509 12.372V12.9924C29.2509 13.1501 29.3788 13.2781 29.5366 13.2781C29.6943 13.2781 29.8223 13.1501 29.8223 12.9924V12.372C30.9649 12.2519 31.8524 11.4223 31.8524 10.4194C31.8524 9.4165 30.9649 8.58694 29.8223 8.46682V5.67694C30.6486 5.78651 31.281 6.36238 31.281 7.0546ZM27.792 7.0546C27.792 6.36238 28.4244 5.7865 29.2508 5.67694V8.43226C28.4244 8.32269 27.792 7.7467 27.792 7.0546ZM31.281 10.4194C31.281 11.1116 30.6487 11.6875 29.8223 11.7971V9.04186C30.6486 9.15132 31.281 9.7273 31.281 10.4194Z"
          fill={theme.palette.primary.main}
        />
        <path
          d="M29.5372 2.27441C25.9735 2.27441 23.0746 5.17352 23.0746 8.73701C23.0746 9.00549 23.0918 9.27701 23.1255 9.5462L20.8991 11.7122C20.8239 11.7851 20.7949 11.8933 20.8231 11.994C20.8514 12.0948 20.9325 12.1721 21.0344 12.1955L24.7169 13.0392C25.9442 14.4135 27.6955 15.1997 29.537 15.1997C33.1007 15.1997 35.9996 12.3006 35.9996 8.73708C35.9996 5.17338 33.1005 2.27448 29.537 2.27448L29.5372 2.27441ZM29.5372 14.6281C27.8301 14.6281 26.2078 13.8867 25.0864 12.594C25.0467 12.5481 24.9935 12.5163 24.9345 12.5027L21.6738 11.7557L23.6273 9.85529C23.6931 9.79119 23.7242 9.69944 23.7107 9.60861C23.6678 9.31951 23.646 9.02631 23.646 8.73708C23.6461 5.48868 26.2888 2.84568 29.5371 2.84568C32.7854 2.84568 35.4285 5.4885 35.4285 8.73678C35.4285 11.9852 32.7857 14.6279 29.5371 14.6279L29.5372 14.6281Z"
          fill={theme.palette.primary.main}
        />
      </g>
      <defs>
        <clipPath id="clip0_566_3750">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const SecureReliableIcon = () => {
  const theme = useTheme();
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.1568 15.3673L16.5196 19.4878L14.7962 17.9629C14.5824 17.7741 14.2538 17.7932 14.0639 18.0075C13.8739 18.2222 13.8942 18.5498 14.1084 18.7398L16.2208 20.6086C16.316 20.6926 16.4386 20.7388 16.5647 20.7388C16.5752 20.7388 16.5859 20.7383 16.5965 20.7377C16.7338 20.7291 16.8623 20.6663 16.9536 20.5635L20.9348 16.054C21.1242 15.8393 21.1039 15.5116 20.8892 15.3217C20.6744 15.1323 20.3473 15.1525 20.1568 15.3673L20.1568 15.3673Z"
        fill={theme.palette.primary.main}
      />
      <path
        d="M17.4994 11.6099C13.9948 11.6099 11.1436 14.4613 11.1436 17.9657C11.1436 21.4701 13.995 24.3215 17.4994 24.3215C21.0038 24.3215 23.8552 21.4701 23.8552 17.9657C23.8552 14.4613 21.0038 11.6099 17.4994 11.6099ZM17.4994 23.2845C14.5666 23.2845 12.1806 20.8987 12.1806 17.9657C12.1806 15.0329 14.5665 12.6469 17.4994 12.6469C20.4322 12.6469 22.8182 15.0328 22.8182 17.9657C22.8182 20.8986 20.4322 23.2845 17.4994 23.2845Z"
        fill={theme.palette.primary.main}
      />
      <path
        d="M28.9999 13.2676C28.9817 12.0936 28.9224 10.8726 28.8237 9.63785C28.7883 9.20535 28.571 8.92277 28.1577 8.77388C24.7615 7.55433 21.3691 6.32467 17.9775 5.09208C17.6438 4.97155 17.3389 4.96899 17.0193 5.0865C13.6286 6.32069 10.2358 7.54999 6.84053 8.77C6.43336 8.91634 6.21658 9.1959 6.17762 9.62538C5.9512 12.1501 5.94109 14.4125 6.14822 16.542C6.44856 19.6349 7.13122 22.088 8.2966 24.2623C10.1199 27.6631 12.833 29.8449 16.3608 30.7459C16.6935 30.831 17.085 30.9307 17.5125 30.9307C17.6766 30.9307 17.8462 30.9161 18.02 30.8801C18.965 30.6841 19.7743 30.4359 20.4941 30.1203C23.7601 28.6861 26.0489 26.2036 27.4908 22.5302C28.5098 19.9346 28.9752 17.0815 29 13.2794L28.9999 13.2676ZM26.5253 22.1513C25.1888 25.5562 23.0795 27.8525 20.0773 29.1703C19.425 29.4564 18.683 29.6833 17.8094 29.8641C17.4179 29.9472 17.0118 29.8413 16.6172 29.741C13.3374 28.9028 10.9145 26.9506 9.21074 23.7719C8.11221 21.7228 7.46699 19.3936 7.18035 16.4415C6.98182 14.3933 6.98995 12.2125 7.21069 9.73907C10.6013 8.52056 13.9886 7.29349 17.3747 6.06066C17.4537 6.03126 17.5089 6.02521 17.6233 6.06671C20.9982 7.29381 24.3748 8.51688 27.7914 9.74705C27.887 10.9479 27.9443 12.136 27.9626 13.2781C27.9384 16.9439 27.4947 19.6806 26.5254 22.1511L26.5253 22.1513Z"
        fill={theme.palette.primary.main}
      />
    </svg>
  );
};

const infoSection = [
  {
    key: 'ReachMoreCustomerSection',
    iconAlt: 'Reach More Customers icon',
    icon: <ReachMoreCustomerIcon />,
    title: I18nKeys.SetupPaymentIntegrationReachMoreCustomersTitle,
    subtitle: I18nKeys.SetupPaymentIntegrationReachMoreCustomersSubtitle,
    link: I18nKeys.SetupPaymentIntegrationReachMoreCustomersLink,
    linkText: I18nKeys.SetupPaymentIntegrationLearnMoreLinkText,
  },
  {
    key: 'SimplifyShoppingSection',
    iconAlt: 'Simplify Shopping icon',
    icon: <SimplifyShoppingIcon />,
    title: I18nKeys.SetupPaymentIntegrationSimplifyShoppingTitle,
    subtitle: I18nKeys.SetupPaymentIntegrationSimplifyShoppingSubtitle,
    link: I18nKeys.SetupPaymentIntegrationSimplifyShoppingLink,
    linkText: I18nKeys.SetupPaymentIntegrationLearnMoreLinkText,
  },
  {
    key: 'SecureReliableSection',
    iconAlt: 'Secure & Reliable icon',
    icon: <SecureReliableIcon />,
    title: I18nKeys.SetupPaymentIntegrationSecureRiableTitle,
    subtitle: I18nKeys.SetupPaymentIntegrationSecureRiableSubtitle,
    link: I18nKeys.SetupPaymentIntegrationSecureRiableLink,
    linkText: I18nKeys.SetupPaymentIntegrationLearnMoreLinkText,
  },
];

const TopContent = {
  [IntegrationStatus.Disconnected]: {
    title: I18nKeys.SetupPaymentIntegrationTitle,
    subtitle: I18nKeys.SetupPaymentIntegrationSubtitle,
    iconKey: undefined,
    defaultMessage: undefined,
    buttonTitle: I18nKeys.SetupPaymentIntegrationGetStarted,
  },
  [IntegrationStatus.Pending]: {
    title: I18nKeys.SetupPaymentIntegrationPendingTitle,
    subtitle: I18nKeys.SetupPaymentIntegrationPendingSubtitle,
    iconKey: MenuIconKey.ATTENTION,
    buttonTitle: I18nKeys.SetupPaymentIntegrationViewDetails,
    defaultMessage: I18nKeys.SetupPaymentIntegrationPendingDefaultMessage,
  },
  [IntegrationStatus.Failed]: {
    title: I18nKeys.SetupPaymentIntegrationFailedTitle,
    subtitle: I18nKeys.SetupPaymentIntegrationFailedSubtitle,
    iconKey: MenuIconKey.WARNING,
    buttonTitle: I18nKeys.SetupPaymentIntegrationFixProblems,
    defaultMessage: I18nKeys.SetupPaymentIntegrationFailedDefaultMessage,
  },
};

interface StyleProps {
  disconnected: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>(() => ({
  root: { width: '100%', height: '100%', padding: '50px 62px 20px 62px' },
  flex: { display: 'flex' },
  topSection: ({ disconnected }: StyleProps) => ({
    width: '100%',
    flexGrow: disconnected ? 1 : 0,
  }),
  chartIconCircle: {
    height: 0,
    width: 0,
    minWidth: '91px',
    minHeight: '91px',
    background: '#0000001A',
    borderRadius: '50%',
    margin: '0 24px',
    display: 'flex',
  },
  topSectionMiddleContainer: { display: 'flex', flexGrow: 1, width: 0, minWidth: '160px' },
  topSectionMiddleContainerDiv: { padding: '0px 40px' },
  topSectionTitle: {
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '23.44px',
    color: '#000',
  },
  topSectionSubtitle: {
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '22px',
    color: '#1E1E1E',
    paddingTop: '12px',
  },
  topIconContainer: { width: '100%', marginTop: '12px' },
  topIconStatusText: {
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '22px',
    paddingTop: '3px',
    color: '#1E1E1E',
  },
  topButtonContainer: { marginTop: '24px', marginRight: '12px' },
  button: {
    borderRadius: '4px',
    padding: '12px 38px',
    textTransform: 'none',
  },
  buttonText: {
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '16px',
    whiteSpace: 'nowrap',
  },
  middleContainer: {
    flexGrow: 1,
  },
  middleItemContainer: { padding: '0px 28px' },
  middleItemText: {
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '22px',
    color: '#000',
    marginTop: '12px',
  },
  middleItemSubtitle: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    color: '#323B4B',
    marginTop: '12px',
  },
  middleItemLink: {
    marginTop: '12px',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
  },
  bottomContainer: { flexGrow: 1 },
  bottomTopContainer: {
    display: 'flex',
    flex: '1',
    padding: '0px 28px 12px',
    alignItems: 'start',
    justifyContent: 'start',
    width: '100%',
    flexDirection: 'column',
  },
  bottomWhatYouNeedText: {
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '22px',
    color: '#000',
  },
  bottomList: {
    padding: '0px 24px 0px',
  },
  bottomListShare: {
    margin: '0px',
    padding: '0px 24px 0px',
  },
  bottomListItem: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#323B4B',
  },
  bottomGrayContainer: { padding: '28px', borderRadius: '10px', backgroundColor: '#F7F7F7' },
  bottomSetupText: {
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '23.44px',
    textAlign: 'left',
    color: '#000',
    alignSelf: 'center',
  },
  bottomButtonContainer: { display: 'flex', alignItems: 'center', justifyContent: 'end' },
  bottomButton: {
    borderRadius: '4px',
    padding: '11px 37px',
    textTransform: 'none',
  },
  bottomIntegrationLink: {
    padding: '28px 0px 0px 28px',
  },
}));

export const SetupPaymentIntegration: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { user } = useAppSelector((state) => state.currentUser);
  const { paymentIntegrationStatus = { status: IntegrationStatus.Disconnected } } = useAppSelector(
    (state) => state.viewer,
  );
  const disconnected = paymentIntegrationStatus.status === IntegrationStatus.Disconnected;
  const classes = useStyles({ disconnected });
  const documentList = [
    I18nKeys.SetupPaymentIntegrationWhatYouWillNeedDocuments,
    I18nKeys.SetupPaymentIntegrationWhatYouWillNeedBank,
  ];

  const onClickIntegrationsLink = () => {
    dispatch(setMainMenuItem(MainMenuItems.Integrations));
  };

  const handleButtonClick = () => {
    if (paymentIntegrationStatus.status === IntegrationStatus.Disconnected) {
      dispatch(openDialog({ dialog: Dialogs.SetupPaymentIntegration }));
    } else {
      dispatch(startPaymentIntegration());
      dispatch(
        openDialog({
          dialog: Dialogs.Loading,
          options: {
            title: t(I18nKeys.SetupPaymentIntegrationLoadingTitle),
            content: t(I18nKeys.SetupPaymentIntegrationLoadingContent),
          },
        }),
      );
    }
  };

  if (
    paymentIntegrationStatus.status === IntegrationStatus.Deactivated ||
    paymentIntegrationStatus.status === IntegrationStatus.Connected
  ) {
    return <div />;
  }

  return (
    <>
      <Stack className={classes.root} direction="column" alignItems="center" spacing={4} divider={<Divider flexItem />}>
        <Grid className={classes.topSection} container size={12}>
          <Grid className={classes.flex}>
            <div className={classes.chartIconCircle}>
              <img alt="Chart Icon" src={chartIconSrc} style={{ margin: 'auto' }} />
            </div>
          </Grid>
          <Grid className={classes.topSectionMiddleContainer} size="auto">
            <div className={classes.topSectionMiddleContainerDiv}>
              <Typography className={classes.topSectionTitle}>
                {t(TopContent[paymentIntegrationStatus.status].title)}
              </Typography>
              <Typography
                className={classes.topSectionSubtitle}
                dangerouslySetInnerHTML={{
                  __html: t(TopContent[paymentIntegrationStatus.status].subtitle),
                }}
              />
              {TopContent[paymentIntegrationStatus.status].iconKey && (
                <Stack className={classes.topIconContainer} direction="row">
                  <MenuIcon iconKey={TopContent[paymentIntegrationStatus.status].iconKey} />
                  <Typography className={classes.topIconStatusText}>
                    <Trans
                      i18nKey={I18nKeys.SetupPaymentIntegrationStatus as string}
                      values={{
                        message:
                          paymentIntegrationStatus.message ||
                          t(TopContent[paymentIntegrationStatus.status].defaultMessage || ''),
                      }}
                      components={{ bold: <strong /> }}
                    />
                  </Typography>
                </Stack>
              )}
            </div>
          </Grid>
          <Grid className={classes.topButtonContainer}>
            <Button color="primary" variant="contained" onClick={handleButtonClick} className={classes.button}>
              <Typography className={classes.buttonText}>
                {t(TopContent[paymentIntegrationStatus.status].buttonTitle)}
              </Typography>
            </Button>
          </Grid>
        </Grid>
        {disconnected && (
          <Grid className={classes.middleContainer} container size={12}>
            {infoSection.map((item) => (
              <Grid key={item.key} size={4} className={classes.middleItemContainer}>
                {item.icon}
                <Typography
                  className={classes.middleItemText}
                  dangerouslySetInnerHTML={{
                    __html: t(item.title),
                  }}
                />
                <Typography className={classes.middleItemSubtitle}>{t(item.subtitle)}</Typography>
                {t(item.link) && (
                  <Typography className={classes.middleItemLink}>
                    <a href={t(item.link)} target="_blank" rel="noreferrer">
                      {`${t(item.linkText)}`}
                    </a>
                  </Typography>
                )}
              </Grid>
            ))}
          </Grid>
        )}
        {disconnected && (
          <Grid className={classes.bottomContainer} container direction="column" size={12}>
            <Grid className={classes.bottomTopContainer} container spacing={0}>
              <Typography className={classes.bottomWhatYouNeedText}>
                {t(I18nKeys.SetupPaymentIntegrationWhatYouWillNeed)}
              </Typography>
              <ul className={classes.bottomList}>
                {documentList.map((doc) => (
                  <li key={doc}>
                    <Typography className={classes.bottomListItem}>{t(doc)}</Typography>
                  </li>
                ))}
              </ul>
              <Typography className={classes.bottomWhatYouNeedText}>
                {t(I18nKeys.SetupPaymentIntegrationWhatYouWillShare)}
              </Typography>
              <ul className={classes.bottomListShare}>
                <li>
                  <Typography className={classes.bottomListItem}>
                    <Trans
                      i18nKey={I18nKeys.SetupPaymentIntegrationWhatYouWillShareItem as string}
                      components={{
                        learnMore: (
                          // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
                          <a
                            href={t(I18nKeys.SetupPaymentIntegrationWhatYouWillShareItemLink)}
                            target="_blank"
                            rel="noreferrer"
                          />
                        ),
                        adyen: (
                          // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
                          <a
                            href={t(I18nKeys.SetupPaymentIntegrationWhatYouWillShareItemAdyenLink)}
                            target="_blank"
                            rel="noreferrer"
                          />
                        ),
                      }}
                    />
                  </Typography>
                </li>
              </ul>
            </Grid>
            <Grid className={classes.bottomGrayContainer} container>
              <Grid className={classes.flex} size={6}>
                <Typography className={classes.bottomSetupText}>
                  {t(I18nKeys.SetupPaymentIntegrationStartAcceptingOrder)}
                </Typography>
              </Grid>
              <Grid className={classes.bottomButtonContainer} size={6}>
                <Button onClick={handleButtonClick} className={classes.bottomButton} color="primary" variant="outlined">
                  <Typography className={classes.buttonText}>
                    {t(I18nKeys.SetupPaymentIntegrationGetStarted)}
                  </Typography>
                </Button>
              </Grid>
            </Grid>
            {isIdeaRoomUser(user) && (
              <Grid className={classes.bottomIntegrationLink} container>
                <A className={classes.link} href={AppRoutes.Integrations} onClick={onClickIntegrationsLink}>
                  {`${t(I18nKeys.SetupPaymentIntegrationConfigurePaymentService)}`}
                </A>
              </Grid>
            )}
          </Grid>
        )}
      </Stack>

      <SetupPaymentIntegrationDialog />
      <SetupPaymentIntegrationConfirmationDialog />
    </>
  );
};
